import * as types from '../mutation-types'
import {
  GET_STUDENT_ASSESSMENTS_LIST
} from '../action-types'
import server from '../server'

const state = {
  studentId: 0,
  allLoaded: false,
  assessmentsLoading: false,
  studentAssessments: []
}

const mutations = {
  [types.SET_STUDENT_ASSESSMENTS_LIST] (state, list) {
    state.studentAssessments = list.map(assessment => {
      assessment.isOpen = false
      return assessment
    })
  },
  [types.SET_STUDENT_ASSESSMENTS_LIST_LOADING] (state, {loading, currentPage, allLoaded}) {
    state.loadingList = loading
    if (loading) {
      state.currentPage = currentPage
      state.allLoaded = false
    } else {
      state.allLoaded = allLoaded
    }
  },
  [types.SET_STUDENT_ASSESSMENTS_SHOW_STATE] (state, id) {
    const assessment = state.studentAssessments.find(int => int.id === id)
    assessment.isOpen = !assessment.isOpen
  },
  [types.SET_STUDENT_ASSESSMENTS_LOADING] (state, loading) {
    state.assessmentsLoading = loading
  },
  [types.SOFT_RESET_ASSESSMENT_LIST] (state) {
    state.studentAssessments = []
  }
}

const actions = {
  [GET_STUDENT_ASSESSMENTS_LIST] ({commit, state}, studentId) {
    const actionData = { action: GET_STUDENT_ASSESSMENTS_LIST, data: studentId }
    commit(types.SOFT_RESET_ASSESSMENT_LIST)
    commit(types.SET_STUDENT_ASSESSMENTS_LOADING, true)
    server.getReplayable(`/core/student/${studentId}/get/assessment`, actionData)
      .then(res => {
        commit(types.SET_STUDENT_ASSESSMENTS_LIST, res.data)
        commit(types.SET_STUDENT_ASSESSMENTS_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(types.SET_STUDENT_ASSESSMENTS_LOADING, false)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/assessmentsModule.js